import React from "react";
import { AccountSummaryData } from "../AccountSummary.slice";
import { formatServiceAddressShort } from "../utils/accountListDisplay";

interface PropsInterface {
  account: AccountSummaryData;
  className?: string;
  nameBadge?: React.ReactNode;
  accountNumberBadge?: React.ReactNode;
  showServiceAddress?: boolean;
  detailLine?: React.ReactNode;
}

export const ServiceAccountLabel: React.FC<PropsInterface> = ({
  account,
  className = "account-dropdown-toggle-label",
  nameBadge,
  accountNumberBadge,
  showServiceAddress = true,
  detailLine,
}) => {
  const serviceAddressLine = showServiceAddress
    ? formatServiceAddressShort(account)
    : null;

  return (
    <span className={className}>
      <span className="service-account-label-name-row">
        <strong>{account.accountName}</strong>
        {nameBadge}
      </span>
      {account.accountNumber && (
        <>
          <br />
          {accountNumberBadge ? (
            <span className="account-dropdown-account-row">
              <span className="service-account-label-detail">
                {account.accountNumber}
              </span>
              {accountNumberBadge}
            </span>
          ) : (
            <span className="service-account-label-detail">
              {account.accountNumber}
            </span>
          )}
        </>
      )}
      {serviceAddressLine && (
        <>
          <br />
          <span className="service-account-label-detail">
            {serviceAddressLine}
          </span>
        </>
      )}
      {detailLine && (
        <>
          <br />
          <span className="service-account-label-payment-method">
            {detailLine}
          </span>
        </>
      )}
    </span>
  );
};
